import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
  'container',
  'content',
  'title',
  'body',
  'link',
  'closeButton',
]);

const baseStyle = definePartsStyle(({ colorScheme: c }) => ({
  container: {
    w: 'full',
    bgColor: `${c}.100`,
    borderBottomWidth: '1px',
    borderBottomColor: `${c}.300`,
    // Same responsive inset as the Home screen, so the copy lines up with the page content.
    px: { base: '4', md: '8', lg: '20', xl: '40' },
    py: '3',
    gap: '4',
    alignItems: 'center',
  },
  content: {
    flex: '1',
  },
  title: {
    textStyle: 'bodySmallSemibold',
  },
  body: {
    textStyle: 'bodySmallRegular',
  },
  link: {
    color: 'primary.600',
    fontWeight: '600',
    textDecoration: 'underline',
    textUnderlineOffset: '2px',
    _hover: {
      color: 'primary.700',
    },
  },
  closeButton: {
    color: 'text.subtle',
  },
}));

const variants = {
  // Title over body, left-aligned with the page content.
  titled: definePartsStyle({
    body: {
      color: 'text.paragraph',
    },
  }),
  // A single centred line of body copy.
  inline: definePartsStyle({
    content: {
      textAlign: 'center',
    },
    body: {
      color: 'text.default',
    },
  }),
};

export default defineMultiStyleConfig({
  baseStyle,
  variants,
  defaultProps: {
    variant: 'inline',
    colorScheme: 'primary',
  },
});
